


import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { fetchServiceDashboardData } from "../../../../redux/reducers/serviceDashboardSlice";

const MedicalServicesChart = () => {
  const dispatch = useDispatch();
  const { usedmedical, loading } = useSelector((state) => state.serviceDashboard);
  const [view, setView] = useState("Month");
  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    dispatch(fetchServiceDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (!usedmedical || !usedmedical[view]) {
      setSeries([]);
      setCategories([]);
      return;
    }

    const medicalData = usedmedical[view] || [];

    setSeries([
      {
        name: "Usage Count",
        data: medicalData?.map((item) => item?.total ?? 0),
      },
    ]);
    setCategories(medicalData?.map((item) => item?.serviceName ?? ''));
  }, [usedmedical, view]);

  const options = {
    chart: { type: "bar", height: 350, toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "60%",
        distributed: true, // 🔥 Enables different colors per bar
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: 5,
      style: { fontSize: "13px", colors: ["#000"] },
      formatter: (val) => `${val.toLocaleString("en-IN")}`, // shows raw usage count
    },
    colors: ["#0052CC", "#1ABC7B", "#FFA800", "#FF4C96", "#9B51E0", "#00B8D9", "#FF5630"], // 🔥 different colors for top 7
    xaxis: {
      categories,
      labels: { style: { fontSize: "14px" } },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toLocaleString("en-IN")} usages`,
      },
    },
    grid: {
      show: true,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: false } },
    },
  };

  return (
    <div className="chart-card" style={{ background: "#fff", padding: 20, borderRadius: 8 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
        <h3 style={{ margin: 0 }}>Frequently Used Medical Services</h3>
        {/* <div style={{ display: "flex", gap: 8 }}>
          {["Week", "Month", "Year"].map((v) => (
            <button
              key={v}
              onClick={() => setView(v)}
              style={{
                padding: "4px 10px",
                backgroundColor: view === v ? "#003b91" : "#e0e0e0",
                color: view === v ? "#fff" : "#000",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              {v}
            </button>
          ))}
        </div> */}

        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={(_, val) => val && setView(val)}
          size="small"
          sx={{
            backgroundColor: '#f0f2f5',
            borderRadius: '12px',
            '& .MuiToggleButtonGroup-grouped': {
              borderRadius: '7px',
              borderColor: 'transparent',
              color: '#333',
              transition: 'none',
              '&.Mui-selected': {
                backgroundColor: '#005EB8',
                color: '#fff',
              },
            },
          }}
        >
          <ToggleButton value="Week">Week</ToggleButton>
          <ToggleButton value="Month">Month</ToggleButton>
          <ToggleButton value="Quarter">Quarter</ToggleButton>
          <ToggleButton value="Year">Year</ToggleButton>
        </ToggleButtonGroup>
      </div>

      <Chart options={options} series={series} type="bar" height={300} />
    </div>
  );
};

export default MedicalServicesChart;
